import { render, staticRenderFns } from "./no8UserList.vue?vue&type=template&id=4cbffa04&scoped=true"
import script from "./no8UserList.vue?vue&type=script&lang=ts"
export * from "./no8UserList.vue?vue&type=script&lang=ts"
import style0 from "./no8UserList.vue?vue&type=style&index=0&id=4cbffa04&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbffa04",
  null
  
)

export default component.exports